import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalDaycare: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M9.578 5.647a4.161 4.161 0 0 1-.804-.091c-.508-.668-1.243-1.465-2.422-2.024l.425-.891c.283.14.544.316.787.52a.603.603 0 0 1 .91-.083l1.106 1.07.062-.086c.123-.553.524-1.947 1.613-2.667 1.374-.914 3.787-.143 3.787-.143s-.75 1.734-2.125 2.646c-1.082.719-2.516.553-3.078.45l-.021.03.06.06a.603.603 0 0 1-.42 1.036l.118.17.002.003ZM7.034 17.942c.303.027.556-.04.872-.125.404-.108.91-.243 1.748-.243.84 0 1.345.135 1.748.243.316.084.57.152.872.125 2.738-.244 6.002-7.928 3.34-10.971l-.018-.02c-.203-.233-1.256-1.443-2.801-1.608-.598-.063-.969.061-1.388.202-.412.138-.87.292-1.637.3-.81.008-1.298-.154-1.742-.301-.44-.146-.835-.277-1.454-.214-1.53.154-2.586 1.316-2.84 1.594l-.041.046c-2.479 2.603.523 10.721 3.341 10.972Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
